module.exports = __webpack_public_path__ + "img/tensorflow.7854606a.png";